import React, { useEffect } from "react";
import "../Stylesheets/TechStack.css";
import AOS from "aos";
import "aos/dist/aos.css";

import Benefits from "./Benefits";

const TechStack = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const cardItem = [
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img97719_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img23588_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img38874_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img74436_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img35611_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img86621_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img63693_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img48096_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img76622_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img31049_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img66537_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img19120_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img98361_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img76040_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img39724_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img89344_IMG.png",
    "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img91845_IMG.png",
  ];

  return (
    <section className="techstack-bg container-fluid py-5 position-relative d-flex flex-column align-items-center">
      <div className="container program-content position-relative">
        {/* <div className="position-relative"> */}
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto text-center flex-wrap">
            <h1
              className="display-4 gradient-text py-5 text-center fw-bold  text-light"
              data-aos="fade-down"
              style={{ fontFamily: "'Merriweather', serif" }}
            >
              End-to-End Expertise <br /> Web, Cloud, AI and Cyber Security
            </h1>
            {/* <p
              className="fs-5 text-center text-light py-5"
            >
              Complete domain based technologies taught by engineers
              who work with these technologies and expertised IT Professionals
            </p> */}
          </div>
          {/* </div> */}

          {/* ✅ Scrolling images */}
          <div className="scrolling-wrapper container" data-aos="fade-up">
            <div className="scrolling-content">
              {[
                ...cardItem,
                ...cardItem,
                ...cardItem,
                ...cardItem,
                ...cardItem,
              ].map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="Tech Logo"
                  className="tech-logo"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Benefits />
    </section>
  );
};

export default TechStack;
